import { FC } from 'react';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/input';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { BoxProps } from '@chakra-ui/react';
export interface CbTableSearchbarProps extends BoxProps {
  onTextFilterChange?: (value: string) => void;
  defaultValue?: string;
  iconColor?: string;
  variant?: string;
  placeholder?: string;
}
export const CbTableSearchbar: FC<CbTableSearchbarProps> = ({
  onTextFilterChange,
  defaultValue,
  iconColor = 'cloud.600',
  variant = 'cb-base',
  placeholder,
  ...props
}) => {
  return <InputGroup data-sentry-element="InputGroup" data-sentry-component="CbTableSearchbar" data-sentry-source-file="CbTableSearchbar.tsx">
      <InputLeftElement pointerEvents="none" children={<ICON_BY_NAME.search color={iconColor} />} sx={{
      h: 'var(--chakra-sizes-10)',
      w: 'var(--chakra-sizes-10)'
    }} data-sentry-element="InputLeftElement" data-sentry-source-file="CbTableSearchbar.tsx" />
      <Input aria-label="cb-searchbar" defaultValue={defaultValue} data-testid="search-filter" borderRadius={50} placeholder={placeholder || 'Search'} style={{
      paddingLeft: '2.5rem',
      marginTop: '1px',
      fontWeight: 600
    }} onChange={event => onTextFilterChange?.(event.target.value)} variant={variant} {...props} data-sentry-element="Input" data-sentry-source-file="CbTableSearchbar.tsx" />
    </InputGroup>;
};